module.exports = __webpack_public_path__ + "img/up_btn.ec420eab.svg";